import OverviewSchedule from "entities/Deal/components/OverviewSchedule";
import { IMemoSection } from "entities/Memo/sdk";

const SectionSchedule = ({
  dealId,
  externalToken,
  section,
  onUpdate,
}: {
  dealId: number;
  externalToken?: string;
  section?: IMemoSection;
  onUpdate?: () => void;
}) => (
  <OverviewSchedule
    dealId={dealId}
    externalToken={externalToken}
    section={section}
    onUpdate={onUpdate}
  />
);

export default SectionSchedule;
